/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SubmissionStatus {
  Pending = "Pending",
  Processing = "Processing",
  Completed = "Completed",
  Validating = "Validating",
  SavedForLater = "SavedForLater",
  Failed = "Failed",
  Uploading = "Uploading",
  UnableToSubmit = "UnableToSubmit",
  FailedValidationAtCrb = "FailedValidationAtCrb",
}

export enum SubmissionFileType {
  ParticipatingInstitution = "ParticipatingInstitution",
  InstitutionBranch = "InstitutionBranch",
  CreditApplication = "CreditApplication",
  BorrowerCreditAccount = "BorrowerCreditAccount",
  BouncedCheques = "BouncedCheques",
  ParticipatingInstitutionStakeholders = "ParticipatingInstitutionStakeholders",
  BorrowerStakeholders = "BorrowerStakeholders",
  CollateralMaterialCollateral = "CollateralMaterialCollateral",
  CollateralCreditGuarantor = "CollateralCreditGuarantor",
  FinancialMalpracticeData = "FinancialMalpracticeData",
}

export enum Salutation {
  Mr = "Mr",
  Mrs = "Mrs",
  Ms = "Ms",
  Dr = "Dr",
  Prof = "Prof",
  Other = "Other",
}

export enum RequestStatus {
  Pending = "Pending",
  Processing = "Processing",
  Completed = "Completed",
  Failed = "Failed",
}

export enum ProductPurchaseOrderStatus {
  Pending = "Pending",
  Paid = "Paid",
  Cancelled = "Cancelled",
}

export enum ProductPurchaseOrderInvoiceStatus {
  Pending = "Pending",
  Paid = "Paid",
  Cancelled = "Cancelled",
}

export enum ProductPaymentMethod {
  BankDeposit = "BankDeposit",
  MobileMoney = "MobileMoney",
  Free = "Free",
  IoTecWallet = "IoTecWallet",
}

export enum ProductCategory {
  DataSubmission = "DataSubmission",
  CreditReference = "CreditReference",
}

export enum PhoneCategory {
  Mobile = "Mobile",
  Office = "Office",
  Home = "Home",
  Fax = "Fax",
  Other = "Other",
}

export enum IotecVerifyConsentRequestStatus {
  Pending = "Pending",
  Processing = "Processing",
  Completed = "Completed",
  Failed = "Failed",
}

export enum IoTecPayCollectionStatus {
  Pending = "Pending",
  SentToVendor = "SentToVendor",
  Success = "Success",
  Failed = "Failed",
}

export enum IdentificationCategory {
  NIN = "NIN",
  NSSF = "NSSF",
  TIN = "TIN",
  FCN = "FCN",
  Passport = "Passport",
  DrivingPermit = "DrivingPermit",
  VillageCard = "VillageCard",
  Other = "Other",
  BRN = "BRN",
}

export enum Gender {
  Female = "Female",
  Male = "Male",
}

export enum EventCategory {
  Birthday = "Birthday",
  Anniversary = "Anniversary",
  Engaged = "Engaged",
  Other = "Other",
}

export enum EmailCategory {
  Personal = "Personal",
  Work = "Work",
  Other = "Other",
}

export enum DataValidationStatus {
  Pending = "Pending",
  Initiated = "Initiated",
  Processing = "Processing",
  Successful = "Successful",
  Failed = "Failed",
}

export enum CreditReferenceType {
  Individual = "Individual",
  Business = "Business",
}

export enum CreditRefSubStatus {
  Pending = "Pending",
  InitiatedPayment = "InitiatedPayment",
  PaymentFailed = "PaymentFailed",
  InitiatingConsent = "InitiatingConsent",
  SentConsentRequest = "SentConsentRequest",
  ConsentGiven = "ConsentGiven",
  FaceVerificationFailed = "FaceVerificationFailed",
  FetchingReport = "FetchingReport",
  ReportFetchFailed = "ReportFetchFailed",
  ReportFetched = "ReportFetched",
}

export enum CreditRefIdCategory {
  NationalId = "NationalId",
  FinancialCard = "FinancialCard",
  Passport = "Passport",
  RefugeeId = "RefugeeId",
  WorkPermit = "WorkPermit",
  BusinessRegistration = "BusinessRegistration",
  TaxIdentification = "TaxIdentification",
}

export enum ContactUrlCategory {
  Website = "Website",
  Facebook = "Facebook",
  Linkedin = "Linkedin",
  Twitter = "Twitter",
  Other = "Other",
}

export enum ContactCategory {
  Person = "Person",
  Company = "Company",
}

export enum ConsentStatus {
  Pending = "Pending",
  Sent = "Sent",
  Consented = "Consented",
  Rejected = "Rejected",
  Failed = "Failed",
  Expired = "Expired",
}

export enum CompanyCategory {
  PrivateLimited = "PrivateLimited",
  PublicLimited = "PublicLimited",
  SoleProprietorship = "SoleProprietorship",
  Partnership = "Partnership",
  Other = "Other",
}

export enum CivilStatus {
  Single = "Single",
  Married = "Married",
  Divorced = "Divorced",
  Other = "Other",
}

export enum BulkCreditReferenceStatus {
  Pending = "Pending",
  Processing = "Processing",
  Completed = "Completed",
  Error = "Error",
}

export enum AddressCategory {
  Home = "Home",
  Work = "Work",
  Other = "Other",
}

export interface AddressViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: AddressCategory;
  /** @format uuid */
  contactId?: string;
  country: string | null;
  district: string | null;
  county?: string | null;
  subCounty?: string | null;
  village?: string | null;
  parish?: string | null;
  postalCode?: string | null;
  street?: string | null;
  freeForm?: string | null;
  placeId?: string | null;
  latLon?: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  isPrimary?: boolean;
}

export interface ApiKey {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
  isDeleted?: boolean;
  /** @maxLength 200 */
  key?: string | null;
  /** @maxLength 1 */
  ownerName?: string | null;
  /** @format uuid */
  partnerId?: string;
  partner?: Partner;
  isActive?: boolean;
  /** @maxLength 1 */
  role?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  claims?: Claim[] | null;
}

export interface ApiKeyCreateModel {
  /** @format uuid */
  partnerId?: string;
}

export interface ApiKeyResetResponse {
  key?: string | null;
}

export interface ApiKeyViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  ownerName?: string | null;
  /** @format uuid */
  partnerId?: string;
  isActive?: boolean;
  role?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
}

export interface BankAccountViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  bankName?: string | null;
  bankCode: string | null;
  branchName?: string | null;
  branchCode: string | null;
  accountName?: string | null;
  accountNumber: string | null;
  swiftCode?: string | null;
  /** @format uuid */
  contactId?: string;
  isPrimary?: boolean;
}

export interface BaseApproveModel {
  /** @format uuid */
  id?: string;
  /** @minLength 1 */
  remarks: string;
  decision?: boolean;
}

export interface BaseResponse {
  message?: string | null;
  status?: boolean;
  data?: Record<string, string>;
}

export interface BulkCreditReferenceImportRequest {
  /**
   * The wallet to be used in the transaction
   * @format uuid
   */
  walletId?: string;
  /**
   * The wallet to be used in the transaction
   * @format uuid
   */
  docId?: string;
  externalReference?: string | null;
  message?: string | null;
}

export interface BulkCreditReferencePreview {
  /** @format uuid */
  docId?: string;
  document?: DocViewModel;
  /** @format int32 */
  totalRecords?: number;
  errors?: ImportError[] | null;
  sample?: CreditReferenceRequestModel[] | null;
}

export interface BulkCreditReferenceViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  status?: BulkCreditReferenceStatus;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format int32 */
  totalRequests?: number;
  /** @format int32 */
  completedRequests?: number;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  externalReference?: string | null;
  /** @format uuid */
  documentId?: string | null;
  document?: DocViewModel;
  createdBy?: string | null;
  createdByData?: ComboModel;
  message?: string | null;
}

export interface BulkCreditReferenceViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: BulkCreditReferenceViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface Claim {
  issuer?: string | null;
  originalIssuer?: string | null;
  properties?: Record<string, string>;
  subject?: ClaimsIdentity;
  type?: string | null;
  value?: string | null;
  valueType?: string | null;
}

export interface ClaimsIdentity {
  authenticationType?: string | null;
  isAuthenticated?: boolean;
  actor?: ClaimsIdentity;
  bootstrapContext?: any;
  claims?: Claim[] | null;
  label?: string | null;
  name?: string | null;
  nameClaimType?: string | null;
  roleClaimType?: string | null;
}

export interface ComboModel {
  id: string | null;
  name: string | null;
}

export interface CompanyInfo {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface CompanyViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: CompanyCategory;
  name: string | null;
  registrationNumber: string | null;
  /** @format date */
  registrationDate?: string | null;
  /** @format int32 */
  numberOfEmployees?: number | null;
  /** @format uuid */
  contactId?: string;
  /** @format uuid */
  contactPersonId?: string | null;
  contactPerson?: ContactMiniViewModel;
  /** @format uuid */
  accountManagerId?: string | null;
  accountManager?: ContactMiniViewModel;
  countryOfOperation?: string | null;
  industry?: string | null;
  natureOfBusiness?: string | null;
  acceptedTermsAndCondition?: boolean;
}

export interface ConsentCallBackStatus {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  reference: string;
}

export interface ConsentRequestViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  partnerId: string;
  partner?: Partner;
  requestStatus: IotecVerifyConsentRequestStatus;
  customerPhoneNumber: string | null;
  customerEmail: string | null;
  narration: string | null;
  /** @format uuid */
  creditReferenceId: string;
  consentStatus?: ConsentStatus;
  nationalIdData?: FaceVerNationalId;
  consentRequestId?: string | null;
  nationalIdImageUrl?: string | null;
  profileImageUrl?: string | null;
  consentUrl?: string | null;
  rawConsentData?: string | null;
  statusCode?: string | null;
  statusMessage?: string | null;
  /** @format date-time */
  processedAt?: string | null;
  payerPhoneNumber: string | null;
  /** @format uuid */
  paymentId?: string | null;
  paymentStatus?: IoTecPayCollectionStatus;
  paymentVendor?: string | null;
  vendorTransactionId?: string | null;
  payeeNote?: string | null;
  rawPaymentData?: string | null;
  /** @format double */
  amount?: number;
  paymentStatusCode?: string | null;
  paymentStatusMessage?: string | null;
  /** @format date-time */
  paymentProcessedAt?: string | null;
}

export interface ContactMiniViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format uuid */
  contactPersonId?: string | null;
  name: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface ContactTagViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  contactId?: string;
  value: string | null;
}

export interface ContactUrlViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  contactId?: string;
  category?: ContactUrlCategory;
  value: string | null;
  isPrimary?: boolean;
}

export interface ContactViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: ContactCategory;
  person?: PersonViewModel;
  company?: CompanyViewModel;
  /** @format uuid */
  partnerId?: string;
  partner?: ContactMiniViewModel;
  occasions?: EventViewModel[] | null;
  identifications?: IdentificationViewModel[] | null;
  phones?: PhoneViewModel[] | null;
  emails?: EmailViewModel[] | null;
  addresses?: AddressViewModel[] | null;
  urls?: ContactUrlViewModel[] | null;
  tags?: ContactTagViewModel[] | null;
  bankAccounts?: BankAccountViewModel[] | null;
}

export interface CreditDataSubmissionRequest {
  fileType?: SubmissionFileType;
  isSubmit?: boolean;
  /** @maxLength 100 */
  externalReference?: string | null;
  /** @maxLength 200 */
  notes?: string | null;
  data?: Record<string, string>[] | null;
}

export interface CreditReferenceRequestModel {
  /** External reference to track request */
  referenceId?: string | null;
  /** Determine if we should execute this call in the background */
  isBlocking?: boolean;
  /**
   * The customer for who this request is being made against
   * @format uuid
   */
  customerId?: string | null;
  /**
   * The bulk request to which this Lumen belongs
   * @format uuid
   */
  bulkId?: string | null;
  /** @minLength 1 */
  identificationValue: string;
  identificationCategory?: CreditRefIdCategory;
  /**
   * @format tel
   * @minLength 1
   */
  customerPhoneNumber: string;
  /**
   * @format email
   * @minLength 1
   */
  customerEmail: string;
  /**
   * @format tel
   * @minLength 1
   */
  payerPhoneNumber: string;
  /** @minLength 1 */
  inquiryReason: string;
  creditReferenceType?: CreditReferenceType;
}

export interface CreditReferenceViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format date-time */
  sentAt?: string | null;
  category?: string | null;
  /** @format uuid */
  productId?: string;
  /** @format uuid */
  bulkId?: string | null;
  /** @format uuid */
  customerId?: string | null;
  status?: RequestStatus;
  /** @format date-time */
  startedAt?: string | null;
  /** @format int64 */
  runningBalance?: number;
  /** @format date-time */
  processedAt?: string | null;
  /** @format int32 */
  attemptCount?: number;
  channel?: string | null;
  requestedBy?: string | null;
  requestedByData?: ComboModel;
  referenceId?: string | null;
  errorCode?: string | null;
  errorMessage?: string | null;
  subStatus?: CreditRefSubStatus;
  subjectToken?: string | null;
  reportCreationDate?: string | null;
  reportReferenceNumber?: string | null;
  referenceNumber?: string | null;
  reportStatus?: string | null;
  reportToken?: string | null;
  reportVersion?: string | null;
  customerEmail?: string | null;
  payerPhoneNumber?: string | null;
  identificationValue?: string | null;
  identificationCategory?: CreditRefIdCategory;
  sessionId?: string | null;
  statusCode?: string | null;
  creditReferenceType?: CreditReferenceType;
  /** @format uuid */
  documentId?: string | null;
  document?: DocViewModel;
  inquiryNumber?: string | null;
  inquiryReason?: string | null;
  customerPhoneNumber?: string | null;
  responsePayload?: string | null;
}

export interface CreditReferenceViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: CreditReferenceViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DocViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  name?: string | null;
  contentType?: string | null;
  originalName?: string | null;
  description?: string | null;
  size?: string | null;
  /** @format uuid */
  partnerId?: string;
}

export interface EConsentConfigurationViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  isEnabled?: boolean;
  active?: boolean;
  /** @format uuid */
  partnerId?: string;
}

export interface EmailViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: EmailCategory;
  /** @format uuid */
  contactId?: string;
  value: string | null;
  isPrimary?: boolean;
}

export interface EventViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: EventCategory;
  details: string | null;
  /** @format date */
  value?: string;
  /** @format uuid */
  contactId?: string;
}

export interface ExperianPartnerConfigCreateModel {
  /** @format uuid */
  partnerId: string;
  institutionName: string | null;
  branchIdentificationCode: string | null;
  participatingIdentificationCode: string | null;
  branchName: string | null;
  branchType: string | null;
  dateOpened: string | null;
  password: string | null;
  dsmVersion: string | null;
  userName: string | null;
}

export interface ExperianPartnerConfigEditModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  partnerId: string;
  institutionName: string | null;
  branchIdentificationCode: string | null;
  participatingIdentificationCode: string | null;
  branchName: string | null;
  branchType: string | null;
  dateOpened: string | null;
  password: string | null;
  dsmVersion: string | null;
  userName: string | null;
}

export interface ExperianPartnerConfigViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  partnerId?: string;
  institutionName?: string | null;
  branchIdentificationCode?: string | null;
  participatingIdentificationCode?: string | null;
  branchName?: string | null;
  branchType?: string | null;
  dateOpened?: string | null;
  password?: string | null;
  dsmVersion?: string | null;
  userName?: string | null;
  /** @format date-time */
  lastUpdated?: string | null;
  apiUserName?: string | null;
  apiPassword?: string | null;
}

export interface ExperianPartnerConfigViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: ExperianPartnerConfigViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface FaceVerNationalId {
  /** @maxLength 100 */
  firstName?: string | null;
  /** @maxLength 100 */
  lastName?: string | null;
  /** @maxLength 50 */
  nin?: string | null;
  /** @maxLength 50 */
  cardNumber?: string | null;
  /** @maxLength 50 */
  dateOfBirth?: string | null;
  /** @maxLength 50 */
  dateOfExpiration?: string | null;
}

export interface IdentificationViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: IdentificationCategory;
  /** @format uuid */
  contactId?: string;
  value: string | null;
  issuingCountry?: string | null;
  /** @format date */
  issueDate?: string | null;
  /** @format date */
  expiryDate?: string | null;
  isPrimary?: boolean;
}

export interface ImportError {
  /** @format int32 */
  row?: number;
  /** @format int32 */
  col?: number;
  error?: string | null;
}

export interface IoTecPayCreditTopUpResponse {
  /** @format uuid */
  transactionId?: string;
  payer?: string | null;
  status?: IoTecPayCollectionStatus;
  currency?: string | null;
  /** @format double */
  amount?: number;
  statusCode?: string | null;
  statusMessage?: string | null;
  /** @format double */
  totalTransactionCharge?: number | null;
}

export interface NotFoundResult {
  /** @format int32 */
  statusCode?: number;
}

export interface OkResult {
  /** @format int32 */
  statusCode?: number;
}

export interface Partner {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
  isDeleted?: boolean;
  partnerIps?: PartnerIp[] | null;
  clientIds?: PartnerClientId[] | null;
  members?: PartnerMember[] | null;
  active?: boolean;
  apiKey?: ApiKey;
}

export interface PartnerClientId {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
  isDeleted?: boolean;
  /** @maxLength 150 */
  clientId: string | null;
  partner?: Partner;
  /** @format uuid */
  partnerId?: string;
}

export interface PartnerClientIdViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @maxLength 150 */
  clientId: string | null;
  partner?: ComboModel;
  /** @format uuid */
  partnerId?: string;
}

export interface PartnerCreateModel {
  /** @format uuid */
  id: string;
  partnerIps?: string[] | null;
  clientId?: string | null;
}

export interface PartnerIp {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
  isDeleted?: boolean;
  ipAddress?: string | null;
  partner?: Partner;
  /** @format uuid */
  partnerId?: string;
}

export interface PartnerIpViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @minLength 1 */
  ipAddress: string;
}

export interface PartnerMember {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
  isDeleted?: boolean;
  /** @format uuid */
  partnerId?: string;
  partner?: Partner;
  roles?: string[] | null;
  active?: boolean;
}

export interface PartnerMemberCreateModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  partnerId?: string;
  roles?: string[] | null;
}

export interface PartnerMemberEditModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  partnerId?: string;
  roles?: string[] | null;
}

export interface PartnerMemberInvitationCreateModel {
  /** @format uuid */
  partnerId?: string;
  /** @minLength 1 */
  email: string;
  roles?: string[] | null;
}

export interface PartnerMemberInvitationViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  partner?: ComboModel;
  /** @format uuid */
  partnerId?: string;
  email: string | null;
  roles?: string[] | null;
}

export interface PartnerMemberViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  person?: ContactMiniViewModel;
  active?: boolean;
  roles?: string[] | null;
}

export interface PartnerUpdateModel {
  /** @format uuid */
  id?: string;
  active?: boolean;
  company?: CompanyInfo;
  partnerIps: string[];
}

export interface PartnerViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  name?: string | null;
  active?: boolean;
  company?: XContactModel;
  apiKey?: ApiKeyViewModel;
  partnerIps?: PartnerIpViewModel[] | null;
  clientIds?: PartnerClientIdViewModel[] | null;
}

export interface PersonViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  contactId?: string;
  salutation?: Salutation;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  gender?: Gender;
  civilStatus?: CivilStatus;
  /** @format date */
  dateOfBirth?: string | null;
  profession?: string | null;
}

export interface PhoneViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  contactId?: string;
  category?: PhoneCategory;
  value: string | null;
  isPrimary?: boolean;
}

export interface ProductCreditsIoTecPayTopUpModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: string | null;
  /** @format double */
  credits?: number;
  /** @format double */
  amountToPay?: number;
  /** @minLength 1 */
  memo: string;
  /**
   * @format tel
   * @minLength 1
   */
  mobileMoneyNumber: string;
}

export interface ProductCreditsManualTopUpModel {
  /** @format uuid */
  partnerId?: string;
  /** @minLength 1 */
  productCategory: string;
  /**
   * @format double
   * @min 1
   */
  credits?: number;
  /** @minLength 1 */
  memo: string;
}

export interface ProductCreditsWalletToWalletTopUpModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: string | null;
  /** @format double */
  credits?: number;
  /** @format double */
  amountToPay?: number;
  /** @minLength 1 */
  memo: string;
  /** @minLength 1 */
  walletCode: string;
  walletPin: string | null;
}

export interface ProductPriceBand {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
  isDeleted?: boolean;
  /** @maxLength 50 */
  category?: string | null;
  /** @maxLength 35 */
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
  /** @maxLength 3 */
  currency?: string | null;
}

export interface ProductPriceBandCreateModel {
  /** @maxLength 50 */
  category?: string | null;
  /**
   * @minLength 1
   * @maxLength 35
   */
  name: string;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
}

export interface ProductPriceBandUpdateModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @maxLength 35 */
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
}

export interface ProductPriceBandViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
  /** @format double */
  purchasableCredits?: number;
  /** @format double */
  purchasableAmount?: number;
  category?: string | null;
  currency?: string | null;
}

export interface ProductPurchaseOrderInvoiceViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  /** @format uuid */
  partnerId?: string;
  productCategory?: string | null;
  /** @format uuid */
  purchaseOrderId?: string;
  invoiceNumber: string | null;
  status?: ProductPurchaseOrderInvoiceStatus;
  /** @format date-time */
  dueDate?: string | null;
  memo: string | null;
  partnerAddress?: string | null;
  partnerEmail: string | null;
  partnerPhone: string | null;
  partnerName: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  taxAmount?: number;
  /** @format double */
  credits?: number;
  /** @format double */
  unitPrice?: number;
  /** @format uuid */
  updatedBy?: string | null;
}

export interface ProductPurchaseOrderIoTecPayViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category: string | null;
  currency: string | null;
  walletId: string | null;
  externalId: string | null;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  payer: string | null;
  payerNote: string | null;
  /** @format double */
  amount?: number;
  payeeNote: string | null;
  channel?: string | null;
  transactionChargesCategory: string | null;
  productCategory?: string | null;
  status?: IoTecPayCollectionStatus;
  /** @format double */
  credits?: number;
  /** @format double */
  totalAmountPaid?: number;
  /** @format double */
  transactionCharge?: number;
  /** @format double */
  vendorCharge?: number;
  /** @format double */
  totalTransactionCharge?: number;
  payerName?: string | null;
  /** @format uuid */
  purchaseOrderId?: string;
}

export interface ProductPurchaseOrderPreviewRequestModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: string | null;
  /** @format double */
  credits?: number;
  paymentMethod?: ProductPaymentMethod;
  mobileMoneyNumber?: string | null;
  walletCode?: string | null;
  walletPin?: string | null;
}

export interface ProductPurchaseOrderPreviewResponseModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: string | null;
  /** @format double */
  credits?: number;
  paymentMethod?: ProductPaymentMethod;
  /** @format double */
  amount?: number;
  /** @format double */
  transactionCharges?: number;
  mobileMoneyNumber?: string | null;
  walletCode?: string | null;
  walletPin?: string | null;
}

export interface ProductPurchaseOrderViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  productCategory?: string | null;
  paymentMethod?: ProductPaymentMethod;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format uuid */
  requestId?: string;
  memo: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  credits?: number;
  /** @format uuid */
  purchaseOrderDetailId?: string;
  invoiceDetail?: ProductPurchaseOrderInvoiceViewModel;
  ioTecPayDetail?: ProductPurchaseOrderIoTecPayViewModel;
  /** @format uuid */
  priceBandId?: string;
  priceBand?: ProductPriceBand;
}

export interface ProductPurchaseOrderViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: ProductPurchaseOrderViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface ProductSubscriptionViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  category?: string | null;
  /** @format double */
  creditsBalance?: number;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format uuid */
  priceBandId?: string;
  priceBand?: ComboModel;
}

export interface ProductTopUpInvoiceCreateModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: string | null;
  /** @format uuid */
  requestId?: string;
  /** @format date-time */
  dueDate?: string;
  memo: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  taxAmount?: number;
  /** @format double */
  credits: number;
}

export interface ProductTopUpInvoicePayModel {
  /** @format uuid */
  invoiceId?: string;
  /** @format uuid */
  partnerId?: string;
  memo: string | null;
}

export interface SubmissionRequestImportModel {
  fileType?: SubmissionFileType;
  isSubmit?: boolean;
  /** @format uuid */
  docId?: string;
  /** @maxLength 100 */
  externalReference?: string | null;
  /** @maxLength 200 */
  notes?: string | null;
}

export interface SubmissionRequestUploadModel {
  /**
   * File
   * @format binary
   */
  file?: File | null;
  fileType?: SubmissionFileType;
}

export interface SubmissionRequestViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  createdByData?: ComboModel;
  submissionStatus?: SubmissionStatus;
  dataValidationStatus?: DataValidationStatus;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  submittedBy?: string | null;
  submittedByData?: ComboModel;
  submissionFileType?: SubmissionFileType;
  /** @format date-time */
  submissionDate?: string;
  externalReference?: string | null;
  /** @format uuid */
  documentId?: string | null;
  document?: DocViewModel;
  submissionFileName?: string | null;
  /** @format uuid */
  submissionFileId?: string | null;
  submissionFile?: DocViewModel;
  /** @format uuid */
  responseCsvFileId?: string | null;
  /** @format uuid */
  responsePdfFileId?: string | null;
  /** @format int32 */
  totalRecords?: number;
  published?: boolean | null;
  notes?: string | null;
}

export interface SubmissionRequestViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: SubmissionRequestViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface SystemRole {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  requiresPrimaryUser?: boolean;
  roleCategory?: string | null;
  roleSubCategory?: string | null;
}

export interface UnauthorizedResult {
  /** @format int32 */
  statusCode?: number;
}

export interface XContactModel {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}
